import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.luxor-limo.ch';
const API = `${BACKEND_URL}/api`;

// Custom hook for API calls
export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callApi = async (endpoint, options = {}) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios({
        url: `${API}${endpoint}`,
        method: 'GET',
        ...options
      });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { callApi, loading, error };
};

// Hook for services data
export const useServices = () => {
  const [services, setServices] = useState([]);
  const { callApi, loading, error } = useApi();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await callApi('/services');
        setServices(data);
      } catch (err) {
        console.error('Failed to fetch services:', err);
        // Fallback to empty array if API fails
        setServices([]);
      }
    };

    fetchServices();
  }, []);

  return { services, loading, error };
};

// Hook for fleet data
export const useFleet = () => {
  const [fleet, setFleet] = useState([]);
  const { callApi, loading, error } = useApi();

  useEffect(() => {
    const fetchFleet = async () => {
      try {
        const data = await callApi('/fleet');
        setFleet(data);
      } catch (err) {
        console.error('Failed to fetch fleet:', err);
        // Fallback to empty array if API fails
        setFleet([]);
      }
    };

    fetchFleet();
  }, []);

  return { fleet, loading, error };
};

// Hook for stats data
export const useStats = () => {
  const [stats, setStats] = useState(null);
  const { callApi, loading, error } = useApi();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await callApi('/stats');
        setStats(data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
        // Fallback to default stats
        setStats({
          company: {
            years_experience: "12+",
            availability: "24/7",
            satisfied_clients: 10000,
            destinations: "100+"
          }
        });
      }
    };

    fetchStats();
  }, []);

  return { stats, loading, error };
};